import { Component, OnInit } from '@angular/core';
import { CustomerRegistrationService } from 'src/app/services/customer-registration/customer-registration.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { AgencyMaster, Organization } from 'src/app/shared/common-components/common-structure';
import { UserService } from 'src/app/services/user/user.service';
import { HhgScopeService } from 'src/app/services/hhg-scope/hhg-scope.service';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-login-history-report',
    templateUrl: './login-history-report.component.html',
    styleUrls: ['./login-history-report.component.css'],
    standalone: false
})
export class LoginHistoryReportComponent implements OnInit {
  loginForm: UntypedFormGroup;
  agencyMaster: AgencyMaster[];
  bureauMaster: any;
  customerList: Organization[];
  carrierList: any[];
  isSysAdmin: boolean;
  isAgencyAdmin: boolean;
  isCarrierAdmin: boolean;
  isValidUser: boolean;
  userType: any;
  currentUser: any;
  carrierId: any;
  showDropDownMessage: any;
  showReportFlag: any;
  agencyMasterId: any;
  orgId: any;
  organizationId: any;
  agencyCode: any;
  bureauCode: any;
  paginationPageSize;
  
  domLayout;
  loginRptColumnDefs:any;
  format = 'MM/dd/yyyy';
  locale = 'en-US';
  agencyLoginRptColumnDefs = [ 
    { headerName: 'User Name', field: 'userName', filter: 'agTextColumnFilter', sortable: true,
       cellClass: 'textFormat'},
    { headerName: 'User Email', field: 'userEmail', filter: 'agTextColumnFilter', sortable: true,
       cellClass: 'textFormat'},
    {
      headerName:'Last Login Date',
      valueGetter: (params) => {
        return params.data.loginUpdateDate ? formatDate(params.data.loginUpdateDate, this.format, this.locale) : 'Not Available';
      },
      filter: 'agTextColumnFilter',   
      sortable: true
    },
    {headerName:'Login Status',field:'loginStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'User Phone',field:'userPhone', filter: 'agTextColumnFilter', sortable: true},
    {
      headerName:'User Created Date',
      field:'userCreatedDate', 
      filter: 'agTextColumnFilter',
      valueGetter: (params) => {
        return params.data.userCreatedDate ? formatDate(params.data.userCreatedDate, this.format, this.locale) : 'Not Available';
      },
      sortable: true},
    {headerName:'User Status',field:'userStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Role Name',field:'roleName', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Role Description',field:'roleDesription', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Agency Name',field:'agencyName', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Bureau Name',field:'bureauName', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'POC Name', field: 'orgName', filter: 'agTextColumnFilter', sortable: true,
       cellClass: 'textFormat'},
    {headerName:'POC Email',field:'orgEmail', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'POC Phone',field:'orgPhone', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Org Status',field:'orgStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Org Permission',field:'orgPermission', filter: 'agTextColumnFilter', sortable: true}
  ];
  tspLoginRptColumnDefs = [
    { headerName: 'User Name', field: 'userName', filter: 'agTextColumnFilter', sortable: true,
       cellClass: 'textFormat'},
    { headerName: 'User Email', field: 'userEmail', filter: 'agTextColumnFilter', sortable: true,
       cellClass: 'textFormat'},
    {
      headerName:'Last Login Date',
      field:'loginUpdateDate', 
      filter: 'agTextColumnFilter', 
      sortable: true,
      valueGetter: (params) => {
        return params.data.loginUpdateDate ? formatDate(params.data.loginUpdateDate, this.format, this.locale) : 'Not Available';
      }
    },
    {headerName:'Login Status',field:'loginStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'User Phone',field:'userPhone', filter: 'agTextColumnFilter', sortable: true},
    {
      headerName:'User Created Date',
      field:'userCreatedDate', 
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: (params) => {
        return params.data.userCreatedDate ? formatDate(params.data.userCreatedDate, this.format, this.locale) : 'Not Available';
      }
    },
    {headerName:'User Status',field:'userStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Role Name',field:'roleName', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Role Description',field:'roleDesription', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'SCAC',field:'scac', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'TSP Name',field:'scacName', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'POC Name', field: 'orgName', filter: 'agTextColumnFilter', sortable: true,
       cellClass: 'textFormat'},
    {headerName:'POC Email',field:'orgEmail', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'POC Phone',field:'orgPhone', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Org Status',field:'orgStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName:'Org Permission',field:'orgPermission', filter: 'agTextColumnFilter', sortable: true}
  
  

  ];
  excelStyles = [
    {
       id: 'textFormat',
       dataType: 'string',
     }
  ];
  loginHistoryList: any = [{}];
  loginList: any = [{}];
  getRowHeight = () => 35;
  constructor(private customerRegistrationService: CustomerRegistrationService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private userService: UserService,
              private hhgScopeService: HhgScopeService)
   { }

  ngOnInit(): void {
    this.getUserRole();
    this.createForm();
  }

  getUserRole(){
    this.userType = '';
    this.isAgencyAdmin = false;
    this.isCarrierAdmin = false;
    this.isSysAdmin = false;
    this.isValidUser = false;
    this.showReportFlag = false;
    this.tmssLoader.show();
    this.currentUser = this.userService.getUserDetails().subscribe(user => {
      this.tmssLoader.hide();
      this.currentUser = user;
    
      if (user && user.roles) {
        for (const role of user.roles) {
          if (role.name === 'TSP User Admin'){
            this.isCarrierAdmin = true;
            this.loginRptColumnDefs = this.tspLoginRptColumnDefs;
            this.carrierId = this.currentUser.carrierId;
            this.onSearch();
          }
          else if(role.name === 'System Admin'){
            this.isSysAdmin = true;
            this.loginRptColumnDefs = this.agencyLoginRptColumnDefs;
            this.getAgencyList();
            this.getTspList();
          }
          else if(role.name === 'Agency Admin'){
            this.isAgencyAdmin = true;
            this.loginRptColumnDefs = this.agencyLoginRptColumnDefs;
            //this.getBureauList(this.currentUser.agencyCode);
            this.organizationId = this.currentUser.organizationId;
            this.onSearch();
          }
        }
        if(this.isCarrierAdmin || this.isSysAdmin || this.isAgencyAdmin){
          this.isValidUser = true;
        }
      }
    });
  }
  createForm() {
    this.loginForm = this.fb.group({
      userType: new UntypedFormControl(''),
      agencyName: new UntypedFormControl(''),
      agency: new UntypedFormControl(null, Validators.required),
      agencyCode: new UntypedFormControl(''),
      bureauCode: new UntypedFormControl('', Validators.required),
      customer: new UntypedFormControl(null),
      tsp: new UntypedFormControl(null)
    });
  }
    /*getting agency drop down */
  getAgencyList() {
        this.tmssLoader.show();
        this.customerRegistrationService.getAllAgency().subscribe(
            agencys => {
              this.agencyMaster = agencys;
              this.tmssLoader.hide();
              return this.agencyMaster;
            }, (error) => {
              this.tmssLoader.hide();
              this.alertService.error('Agency drop down did not get populated');
            });
  }

  getTspList(){
    if(this.currentUser.permissions == 'FRT'){
      this.tmssLoader.show();
      this.hhgScopeService.getFRTCarriers().subscribe(
        carrierList => {
          this.carrierList = carrierList;
          this.tmssLoader.hide();
          return this.carrierList;
        },(error) => {
          this.tmssLoader.hide();
        }
      );
    }
    else if(this.currentUser.permissions == 'HHG'){
      this.tmssLoader.show();
      this.hhgScopeService.getAllSmallCarrierListByBusinessTypeAndStatus().subscribe(
        carrierList => {
          this.carrierList = carrierList;
          this.tmssLoader.hide();
          return this.carrierList;
        },(error) => {
          this.tmssLoader.hide();
        }
      );
    }else{
      this.tmssLoader.show();
      this.hhgScopeService.getBothCarrriers().subscribe(
        carrierList => {
          this.carrierList = carrierList;
          this.tmssLoader.hide();
          return this.carrierList;
        },(error) => {
          this.tmssLoader.hide();
        }
      );
    }
  }

  changeUserType(event: any){
    this.showReportFlag = false;
    if(this.isSysAdmin){
      this.userType = this.loginForm.get('userType').value;
      if(this.userType == 'T'){
        this.loginRptColumnDefs = this.tspLoginRptColumnDefs;
      }
      else{
        this.loginRptColumnDefs = this.agencyLoginRptColumnDefs;
      }
    }
  }
 /*
  *  Agency is selected, populatate the Bureau
  */
 changeAgency(event: any) {
    this.showReportFlag = false;
    this.loginForm.get('agency').setValue(event.item.agencyBureauName + ' - ' + event.item.agencyCode);
    this.loginForm.get('agencyName').setValue(event.item.agencyBureauName);
    this.loginForm.get('agencyCode').setValue(event.item.agencyCode);
    this.loginForm.get('bureauCode').setValue('');
    if (event.item.agencyCode !== null) {
      this.getBureauList(event.item.agencyCode);
    }
  } 
  /*
  * Getting Bureau drop down
  */
 getBureauList(agencyCode) {
    this.tmssLoader.show();
    const bureauMaster = [];
    this.customerRegistrationService.getAllBureauForAgency(agencyCode).subscribe(
      bureaus => {
        this.bureauMaster = bureaus;
        this.tmssLoader.hide();
        return this.bureauMaster;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Bureau drop down did not get populated');
      });
  } 
  /*
  * Change Bureau triggers to populate Reporting Official
  */
 changeBureau($event) { 
   this.showReportFlag = false;
   this.bureauMaster.forEach(x => {
    if(x.bureauCode == this.loginForm.controls['bureauCode'].value){
      this.agencyMasterId = x.agencyMasterId;
    }
  });
  
  this.onSearch();
 }

 changeTsp($event){
   this.showReportFlag = false;
   this.carrierId = $event.target.value;
   this.onSearch();
 }

  /*
  *  Reporting Officieal drop down list
  */
 getROList(agencyCode, bureauCode) {
  this.tmssLoader.show();
  this.showDropDownMessage = false;
  if(this.isAgencyAdmin){
    agencyCode = this.currentUser.agencyCode;
  }
  this.customerRegistrationService.getAllReportingOfficial(agencyCode, bureauCode).subscribe(
      repOfficials => {
        this.customerList = repOfficials;
        this.showDropDownMessage = repOfficials.length === 0;
        repOfficials.forEach(repRec => {
        });
        this.tmssLoader.hide();
        return this.customerList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Reporting Official List did not get populated');
      });
  }

  ROChange($event){
    this.orgId = this.loginForm.get('customer').value;
    this.showReportFlag = true;
    this.loginHistoryList=[];
    this.loginList.forEach(x => {
      if (+x.orgId == +this.orgId){
        this.loginHistoryList.push(x);
      }
    });
    
  }
  onSearch(){
    this.showReportFlag = false;
    //this.tmssLoader.show();
    // call to server for data.  Results will be stored in faicListDetails.
    if(this.isSysAdmin && this.loginForm.get('userType').value == 'A'){
      this.tmssLoader.show();
      this.userService.getSysLoginReport(this.agencyMasterId)
        .subscribe(data => {
            this.loginList = data;
            this.loginHistoryList = data;
            this.showReportFlag = true;
            if (this.loginForm.controls['bureauCode'].value !== null &&
                this.loginForm.controls['agencyCode'].value !== null){
                this.getROList(this.loginForm.controls['agencyCode'].value,
                this.loginForm.controls['bureauCode'].value);}
          },
            (error) => {
                console.log('No records found for the search criteria: ' + error);
                this.alertService.error('No records found for the search criteria ');
                this.tmssLoader.hide();
            }, () => {
                console.log('Successfully retrieved document agency report details: ', this.loginHistoryList);
                this.tmssLoader.hide();
            }
        );
      }else if(this.isCarrierAdmin || (this.isSysAdmin && this.loginForm.get('userType').value == 'T')){
        this.tmssLoader.show();
        this.userService.getTspLoginReport(this.carrierId)
          .subscribe(data => {
            this.loginList = data;
            this.loginHistoryList = data;
            this.showReportFlag = true;
          },(error) => {
            //this.errorMessage = error;
            console.log('No records found for the search criteria: ' + error);
            this.alertService.error('No records found for the search criteria ');
            this.tmssLoader.hide();
        }, () => {
            console.log('Successfully retrieved document tsp report details: ', this.loginHistoryList);
            this.tmssLoader.hide();
          });
    }else if(this.isAgencyAdmin){
      this.tmssLoader.show();
        this.userService.getAgencyLoginReport(this.organizationId)
          .subscribe(data => {
            this.loginList = data;
            this.loginHistoryList = data;
            this.showReportFlag = true;
          },(error) => {
            //this.errorMessage = error;
            console.log('No records found for the search criteria: ' + error);
            this.alertService.error('No records found for the search criteria ');
            this.tmssLoader.hide();
        }, () => {
            console.log('Successfully retrieved document tsp report details: ', this.loginHistoryList);
            this.tmssLoader.hide();
          });
    }
  }

}
